<template>
  <div class="app-container">
    <div class="top">
      <el-button size="large" icon="el-icon-plus" type="primary" @click="showDetail(0)">新增</el-button>
      <el-button size="large" icon="el-icon-download"  @click="onDownload">导出</el-button>
      <el-select placeholder="搜索类型" v-model="search.type" style="margin-left:20px">
        <el-option :label="'项目名称'" :value="'projectName'"></el-option>
        <el-option :label="'项目进度'" :value="'progressStatus'"></el-option>
        <el-option :label="'收入合同号'" :value="'incomeContractNo'"></el-option>
        <el-option :label="'合同金额合计'" :value="'incomeContractTotal'"></el-option>
        <el-option :label="'支出合同号'" :value="'disburseContractNo'"></el-option>
        <el-option :label="'项目经理A'" :value="'projectManagerA'"></el-option>
        <el-option :label="'售后经理'" :value="'afterSaleManager'"></el-option>
        <el-option :label="'业务区'" :value="'businessName'"></el-option>
        <el-option :label="'客户经理'" :value="'clientManager'"></el-option>
      </el-select>
      <el-input v-model="search.val" placeholder="请输入搜索内容" style="width:300px;margin-left:20px;"></el-input>
      <el-button size="large" icon="el-icon-search" type="primary" plain @click="getDataList">搜索</el-button>
    </div>
    <el-table :data="dataList" fit highlight-current-row border size="mini">
      <el-table-column prop="projectName" label="项目名称" width="200px" />
      <!-- <el-table-column prop="projectType" label="项目性质" /> -->
      <el-table-column prop="progressStatus" label="项目进度" align="center" width="100px" />
      <!-- <el-table-column prop="projectDescription" label="项目简介" /> -->
      <!-- <el-table-column prop="ownerUnit" label="业主单位" /> -->

      <el-table-column prop="incomeContractNo" label="收入合同号" align="center" width="200px" />
      <!-- <el-table-column prop="incomeContractSigned" label="合同签订主体" align="center" width="200px" /> -->

      <!-- <el-table-column prop="incomeContractSignedDate" label="签订时间" /> -->
      <el-table-column prop="incomeContractTotal" label="合同金额合计" align="center" />

      <!-- <el-table-column prop="incomeContactPerson" label="联系人" />
      <el-table-column prop="incomeContactPhone" label="联系方式" />
    
      <el-table-column prop="incomeDevice" label="设备收入" />
      <el-table-column prop="incomeService" label="服务收入" />
      <el-table-column prop="incomeConstruction" label="施工收入" />
      <el-table-column prop="incomeCt" label="CT收入" />-->
      <!-- <el-table-column prop="incomeContractLimit" label="合同期限" align="center" /> -->
      <!-- <el-table-column prop="incomeAcceptanceDate" label="验收时间" /> -->
      <!-- <el-table-column prop="incomePaymentInfo" label="付款信息" />
      <el-table-column prop="warrantyRecoverDate" label="质保金回收时间" />-->
      <!-- <el-table-column prop="integrators" label="集成商" /> -->
      <el-table-column prop="disburseContractNo" label="支出合同号" align="center" width="200px" />
      <!-- <el-table-column prop="disburseContractSignedDate" label="签订时间" /> -->
      <el-table-column prop="disburseContractTotal" label="支出金额合计" />
      <!-- <el-table-column prop="disburseDevice" label="设备支出" />
      <el-table-column prop="disburseService" label="服务支出" />
      <el-table-column prop="disburseConstruction" label="施工支出" />
      <el-table-column prop="disburseContactPerson" label="联系人" />
      <el-table-column prop="disburseContactPhone" label="联系方式" />-->
      <el-table-column prop="disbursePaymentInfo" label="支出款信息" />
      <el-table-column prop="accrualInfo" label="计收信息" />
      <!-- <el-table-column prop="surplusAccrualAmount" label="剩余计收金额" />-->
      <el-table-column prop="projectManagerA" label="项目经理A" align="center" />
      <!-- <el-table-column prop="onSaleManager" label="售中经理" /> -->
      <el-table-column prop="afterSaleManager" label="售后经理" align="center" />
      <el-table-column prop="businessName" label="业务区" align="center" />
      <el-table-column prop="clientManager" label="客户经理" align="center" />
      <!-- <el-table-column prop="returnVisitCycle" label="回访周期" />
      <el-table-column prop="returnVisitPlan" label="回访计划" />
      <el-table-column prop="returnVisitResult" label="售后回访结果" align="center" width="200px" />-->

      <el-table-column align="center" width="200px" label="操作">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="showDetail(scope.row.id)">编辑</el-button>
          <el-button size="mini" type="success" @click="handleDel(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
        :current-page="pageInfo.currentPage"
        :page-size="pageInfo.pageSize"
        :total="pageInfo.total"
        layout="total, sizes, prev, pager, next, jumper"
        @current-change="onPageChange"
      />
    </div>
    <!-- <app-toolbar
      v-model="list.value"
      v-bind="toolbar"
      @remove="onRemove"
      @download="onDownload"
      @search="onSearch"
    />
    <app-list
      v-model="list.value"
      v-bind="list"
      @selection-change="onSelectionChange"
      ref="list"
    />-->
  </div>
</template>

<script>
import api from "@/api";

export default {
  name: "index",
  components: {},
  data() {
    return {
      pageInfo: {
        currentPage: 1,
        pageSize: 20,
        total: 0,
      },
      // 列表
      dataList: null,
      search: {
        type: "",
        val: "",
      },
    };
  },
  computed: {},
  created() {
    this.getDataList();
  },
  methods: {
    async handleDel(id) {
      await api.implement.apiRemove({ id: id }).then((res) => {
        this.$message({
          message: res.message,
          type: "success",
        });
        this.getDataList();
      });
    },

    onPageChange(page) {
      this.pageInfo.currentPage = page;
      this.getDataList();
    },
    async getDataList() {
      let str = this.search.type;
      const query = {
        currentPage: this.pageInfo.currentPage,
        pageSize: this.pageInfo.pageSize,
      };
      this.$set(query, str, this.search.val);
      await api.implement.getList(query).then((res) => {
        this.dataList = res.data.data;
        this.pageInfo.total = res.data.total;
      });
    },
    showDetail(id) {
      const { $router } = this;
      $router.push({
        path: "implementation/detail",
        query: { id: id },
      });
    },
    // 选中多行
    onSelectionChange(e) {
      this.list.selectedItems = e;
    },
    // 移除后重新加载
    async onRemove() {
      try {
        this.loading = this.$loading({ target: '.app-main' });
        const { id } = this.toolbar;
        const { message } = await api.business.remove({ id });
        this.$notify({ title: '成功', message, type: 'success' });
        await this.$refs.list.getItems();
      } finally {
        this.loading.close();
      }
    },
    onDownload() {
      open("api/implementInfo/exportExcel", "_black");
    },
    async onSearch(e) {
      this.list.search = e;
      await this.$refs.list.getItems();
    },
  },
};
</script>

<style lang="scss" scoped>
.top {
  margin: 20px 0;
}
</style>
